import { LicenseInfo } from '@mui/x-license-pro';
import { FC, useEffect, useState, Suspense, lazy, useReducer } from "react";
import { gql, useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { GetCities } from "./constants/constants";
import { setList } from "./store/cityListReducer";
import AllRoutes from "./routes";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";

// Lazy load all third-party components consistently


Sentry.init({
  dsn: "https://c63afad2c08d90b469682de2bb8bc39f@o4509601604567040.ingest.us.sentry.io/4509601606402048",
  enabled: process.env.NODE_ENV === "production",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE || '');

const randomNumber = (max: number) => Math.floor(Math.random() * max);

const App: FC = () => {
  const dispatch = useDispatch<any>();
  const sp = new URLSearchParams(window.location.search);

  const { loading, error, data } = useQuery(
    gql`
      ${GetCities}
    `
  );
  const [variant] = useState(
    localStorage.getItem("ROMINGO_EXPERIMENT_VAR") || randomNumber(3)
  );


  useEffect(() => {
    localStorage.setItem("ROMINGO_EXPERIMENT_VAR", variant.toString());
    if (!(window as any)._gtmInit) {
      (window as any)._gtmInit = true;
      try {
        TagManager.initialize({
          gtmId: "GTM-MQC9J5B",
          dataLayer: { experimentVar: variant },
          events: {
            search: "Search",
            selectProperty: "Select Property",
            selectRoom: "Select Room",
            checkoutSuccess: "Checkout Success",
            checkoutFail: "Checkout Failure",
          },
        });
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('GTM init failed', e);
        }
      }
    }
    // Handle UTM parameters
    const utmSource = sp.get('utm_source');
    const utmMedium = sp.get('utm_medium');
    if (utmSource) {
      localStorage.setItem('utm_source', utmSource);
    }
    if (utmMedium) {
      localStorage.setItem('utm_medium', utmMedium);
    }
  }, [variant, sp]);
  useEffect(() => {
    if (data) {
      /* eslint-disable-next-line no-unsafe-optional-chaining */
      dispatch(setList([...data?.cities]));
    }
  }, [data, dispatch]);


  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>

      <AllRoutes />

    </div>
  );
};

export default App;
